const STATUS = {
	SOLICITADA: 1,
	APPROVE: 2,
	DISFRUTADA: 3,
	RECHAZADA: 4,
	CANCELADAS: 5,
}
export default STATUS